import { Avatar } from "./Avatar";

export class Profile {
  static compiler() {
    // 头像预览（编辑个人信息 modal）
    Avatar.compiler("#avatar-file-input");
  }
}
